module.exports = __webpack_public_path__ + "img/1_en.20113591.jpg";